const DownloadButton = ({ ButtonName, handleClick }) => {
  return (
    <button className="download-btn" onClick={handleClick} title={ButtonName}>
      {ButtonName}
    </button>
  );
};

export default DownloadButton;
